import { API } from 'aws-amplify';
import {
  PROFILE_USER_LINK_URL_APPEND,
  PROFILE_ADMIN_LINK_URL_APPEND,
} from 'constants';

export const getAdminAllLinks = async () => {
  const adminAllList = await API.get(
    'delta-api',
    `${PROFILE_ADMIN_LINK_URL_APPEND}training-links`,
    {}
  );

  return adminAllList || [];
};

export const getAdminLink = async (linkId) => {
  const adminLink = await API.get(
    'delta-api',
    `${PROFILE_ADMIN_LINK_URL_APPEND}training-links/${linkId}`,
    {}
  );

  return adminLink || [];
};

export const postAdminLink = async (payload) => {
  const myPayload = {
    body: payload,
  };

  await API.post(
    'delta-api',
    `${PROFILE_ADMIN_LINK_URL_APPEND}training-links`,
    myPayload
  );
};

export const putAdminLink = async (payload, link_id) => {
  const myPayload = {
    body: payload,
  };
  const updateAdminLink = await API.put(
    'delta-api',
    `${PROFILE_ADMIN_LINK_URL_APPEND}training-links/${link_id}`,
    myPayload
  );

  return updateAdminLink || [];
};

export const deleteAdminLink = async (linkId) => {
  await API.del(
    'delta-api',
    `${PROFILE_ADMIN_LINK_URL_APPEND}training-links/${linkId}`
  );
};

export const viewLinkEngagement = async (linkId) => {
  const engagementList = await API.get(
    'delta-api',
    `${PROFILE_ADMIN_LINK_URL_APPEND}training-links/${linkId}/engagement`,
    {}
  );

  return engagementList || [];
};

export const getAdminViewLinkUsers = async (linkId) => {
  const viewLinkUsersList = await API.get(
    'delta-api',
    `${PROFILE_ADMIN_LINK_URL_APPEND}training-links/${linkId}/viewed-users`,
    {}
  );

  return viewLinkUsersList || [];
};

export const getAdminUnViewLinkUsers = async (linkId) => {
  const unViewLinkUsersList = await API.get(
    'delta-api',
    `${PROFILE_ADMIN_LINK_URL_APPEND}training-links/${linkId}/unviewed-users`,
    {}
  );

  return unViewLinkUsersList || [];
};

export const updateAdminLinkViewStatus = async (payload, trackerId) => {
  const myPayload = {
    body: payload,
  };

  await API.put(
    'delta-api',
    `${PROFILE_ADMIN_LINK_URL_APPEND}link-trackers/${trackerId}/status`,
    myPayload
  );
};

export const getUserAllLinks = async () => {
  const adminAllList = await API.get(
    'delta-api',
    `${PROFILE_USER_LINK_URL_APPEND}`,
    {}
  );

  return adminAllList || [];
};

export const redirectUserLinks = async (trackerId) => {
  return await API.get(
    'delta-api',
    `${PROFILE_USER_LINK_URL_APPEND}${trackerId}/redirect`,
    {}
  );
};

export const updateUserLinkViewStatus = async (payload, trackerId) => {
  const myPayload = {
    body: payload,
  };

  await API.post(
    'delta-api',
    `${PROFILE_USER_LINK_URL_APPEND}${trackerId}/status`,
    myPayload
  );
};

export const getUserUnviewedinks = async () => {
  const adminAllList = await API.get(
    'delta-api',
    `${PROFILE_USER_LINK_URL_APPEND}unviewed`,
    {}
  );

  return adminAllList || [];
};
